import React, { useEffect } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { pageAddEdit } from "../../../../services/pageService";
import FileUploadMultiple from "../../../form/FileUploadMultiple";

const validation = {
  title: { required: true, message: "Title is required" },
  rotateText: { required: true, message: "Rotate text is required" },
  description: { required: true, message: "Description is required" },
  type: { required: true, message: "This field is required" },
};

const ManagePage = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await pageAddEdit({
        ...val,
        // image,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4">
        <div className="relative col-span-4">
          <Input
            label={`Title`}
            inputPlaceholder={`Enter Title`}
            inputName="title"
            value={values?.title || ""}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label="Description"
            placeholder="Description"
            value={values?.description || ""}
            onChange={(val) =>
              handleChange({
                target: { name: "description", value: val },
              })
            }
            {...formValidate(errors, "description")}
          />
        </div>
        <div className="relative col-span-4">
          <Input
            label={`Rotate Text`}
            inputPlaceholder={`Enter Rotate Text`}
            inputName="rotateText"
            value={values?.rotateText || ""}
            onChange={handleChange}
            {...formValidate(errors, "rotateText")}
          />
        </div>
        <div className="relative col-span-2">
          <Select
            label={"Add for"}
            placeholder="Select type"
            selectedValue={values?.type}
            dropdownData={[
              { name: "Mission", value: "mission" },
              { name: "Vision", value: "vision" },
              { name: "Impact", value: "inpact" },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "type", value: val },
              });
            }}
            {...formValidate(errors, "type")}
          />
        </div>
        <div className="relative col-span-2">
          <Select
            label={"Status"}
            placeholder="Select status"
            selectedValue={values?.status}
            dropdownData={[
              { name: "Active", value: 1 },
              { name: "InActive", value: 2 },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "status", value: val },
              });
            }}
          />
        </div>
        <div className="relative col-span-4">
          <FileUploadMultiple
            label={"Upload image"}
            onChange={(files) =>
              handleChange({ target: { name: "image", value: files } })
            }
            onRemove={(files) =>
              handleChange({ target: { name: "image", value: files } })
            }
            values={values?.image}
            sectionId={data?._id}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={data?._id ? "Update" : "Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManagePage;
